import React, { Component } from 'react';
import { Modal, Button, Input, Form, List, Space, notification } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { withApollo } from 'react-apollo';
import getAutorizacionViajePorId from '../../../graphql/querys/tramites/getAutorizacionMenorPorId.graphql';
import getAutorizacionTrabajoPorId from '../../../graphql/querys/tramites/getAutorizacionTrabajoMenorPorId.graphql';
import enviarEmailAutorizacionViajeMenor from '../../../graphql/mutations/tramites/enviarEmailAutorizacionViajeMenor.graphql';
import enviarEmailAutorizacionTrabajoMenor from '../../../graphql/mutations/tramites/enviarEmailAutorizacionTrabajoMenor.graphql';

const MIGRACIONES_MAIL = 'restricciones@migraciones.gob.ar';

class ModalMandarEmail extends Component {
  state = {
    emails: [],
    nuevoEmail: '',
    cuerpo: '',
    enviando: false,
    cargandoAutorizacion: false,
    defaultEmailsList: this.props.emailDefault && Array.isArray(this.props.emailDefault) 
      ? this.props.emailDefault 
      : [MIGRACIONES_MAIL], // Initialize with prop or default
  };

  componentDidMount() {
    // Initialize emails with emailDefault prop or MIGRACIONES_MAIL
    const defaultEmails = this.props.emailDefault && Array.isArray(this.props.emailDefault) 
      ? this.props.emailDefault 
      : [MIGRACIONES_MAIL];
    this.setState({ emails: defaultEmails, defaultEmailsList: defaultEmails });
  }

  componentDidUpdate(prevProps) {
    // If the modal becomes visible and we have a document ID, fetch the authorization
    if (
      this.props.visibleModalMandarEmail && 
      !prevProps.visibleModalMandarEmail && 
      this.props.idDocumento
    ) {
      this.cargarMailsDeAutorizacion();
    }
  }

  cargarMailsDeAutorizacion = async () => {
    if (!this.props.idDocumento) return;
    
    this.setState({ cargandoAutorizacion: true });
    
    try {
      const isTrabajoMenor = this.props.tipoAutorizacion === 'trabajo';
      const query = isTrabajoMenor ? getAutorizacionTrabajoPorId : getAutorizacionViajePorId;
      const queryField = isTrabajoMenor ? 'getAutorizacionTrabajoPorId' : 'getAutorizacionViajePorId';
      
      const response = await this.props.client.query({
        query: query,
        variables: { _id: this.props.idDocumento },
        fetchPolicy: 'network-only'
      });
      
      const autorizacion = response.data[queryField];
      
      if (autorizacion && autorizacion.mailsNotificar && autorizacion.mailsNotificar.length > 0) {
        const emailsValidos = autorizacion.mailsNotificar
          .filter(email => email && email.trim())
          .map(email => email.trim());
        
        const emailsFinales = [...this.state.defaultEmailsList, ...emailsValidos]
          .filter((email, index, arr) => arr.indexOf(email) === index);
        
        this.setState({ 
          emails: emailsFinales,
          cargandoAutorizacion: false 
        });
      } else {
        this.setState({ 
          emails: this.state.defaultEmailsList,
          cargandoAutorizacion: false 
        });
      }
    } catch (error) {
      console.error('Error al cargar emails de la autorización:', error);
      this.setState({ cargandoAutorizacion: false });
    }
  };

  handleOk = async () => {
    // Validate that there are emails to send to
    if (this.state.emails.length === 0) {
      notification.error({
        message: 'Error',
        description: 'Debe agregar al menos un email para enviar.',
      });
      return;
    }

    if (!this.props.idDocumento) {
      notification.error({
        message: 'Error',
        description: 'No se encontró el ID de la autorización.',
      });
      return;
    }
    
    this.setState({ enviando: true });
    
    try {
      const isTrabajoMenor = this.props.tipoAutorizacion === 'trabajo';
      const mutation = isTrabajoMenor ? enviarEmailAutorizacionTrabajoMenor : enviarEmailAutorizacionViajeMenor;
      const mutationField = isTrabajoMenor ? 'enviarEmailAutorizacionTrabajoMenor' : 'enviarEmailAutorizacionViajeMenor';
      
      const response = await this.props.client.mutate({
        mutation: mutation,
        variables: {
          idAutorizacion: this.props.idDocumento,
          emails: this.state.emails,
        },
      });

      const result = response.data[mutationField];
      
      // Since the backend returns a string, we check if it indicates success
      if (result && !result.toLowerCase().includes('error')) {
        notification.success({
          message: 'Éxito',
          description: result || 'Los emails se han enviado correctamente.',
        });
        
        this.setState({ enviando: false });
        if (this.props.ocultarModalMandarEmail) {
          this.props.ocultarModalMandarEmail();
        }
      } else {
        notification.error({
          message: 'Error',
          description: result || 'Error al enviar los emails.',
        });
        this.setState({ enviando: false });
      }
      if (this.props.onSuccess) {
        this.props.onSuccess();
      }
    } catch (error) {
      console.error('Error al enviar emails:', error);
      notification.error({
        message: 'Error',
        description: 'Error al enviar los emails. Intente nuevamente.',
      });
    }finally{
      this.setState({ enviando: false });
    }
  };

  handleCancel = () => {
    // Reset state when canceling - use defaultEmailsList (without mailsNotificar)
    this.setState({
      emails: this.state.defaultEmailsList,
      nuevoEmail: '',
      cuerpo: '',
      enviando: false,
    });
    if (this.props.ocultarModalMandarEmail) {
      this.props.ocultarModalMandarEmail();
    }
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  agregarEmail = () => {
    const { nuevoEmail, emails } = this.state;
    if (nuevoEmail.trim() && !emails.includes(nuevoEmail.trim())) {
      this.setState({
        emails: [...emails, nuevoEmail.trim()],
        nuevoEmail: '',
      });
    }
  };

  eliminarEmail = (emailToRemove) => {
    this.setState({
      emails: this.state.emails.filter(email => email !== emailToRemove),
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.agregarEmail();
    }
  };

  render() {
    const { visibleModalMandarEmail } = this.props;
    const { emails, nuevoEmail, cuerpo, enviando, cargandoAutorizacion } = this.state;
    
    return (
      <Modal
        title="Enviar Documento por Email"
        visible={visibleModalMandarEmail}
        onCancel={this.handleCancel}
        width={600}
        footer={[
          <Button key="cancel" onClick={this.handleCancel}>
            Cancelar
          </Button>,
          <Button 
            key="send" 
            type="primary" 
            onClick={this.handleOk}
            loading={enviando}
            disabled={emails.length === 0}
          >
            Enviar Email
          </Button>
        ]}
      >
        {cargandoAutorizacion ? (
          <div style={{ textAlign: 'center', padding: '20px' }}>
            Cargando emails de la autorización...
          </div>
        ) : (
          <Form layout="vertical">
            <Form.Item label="Agregar Email">
              <div style={{ display: 'flex', width: '100%' }}>
                <Input
                  name="nuevoEmail"
                  value={nuevoEmail}
                  onChange={this.handleChange}
                  onKeyPress={this.handleKeyPress}
                  placeholder="Ingrese email y presione Enter o haga clic en Agregar"
                  type="email"
                  style={{ flex: 1, marginRight: '8px' }}
                />
                <Button 
                  type="primary" 
                  onClick={this.agregarEmail}
                  disabled={!nuevoEmail.trim()}
                  icon={<Icons.PlusOutlined />}
                >
                  Agregar
                </Button>
              </div>
            </Form.Item>

            <Form.Item label="Lista de Emails">
              {emails.length > 0 ? (
                <List
                  size="small"
                  bordered
                  dataSource={emails}
                  renderItem={(email, index) => (
                    <List.Item
                      key={index}
                      actions={[
                        <Button
                          key="delete"
                          type="link"
                          danger
                          size="small"
                          icon={<Icons.DeleteOutlined />}
                          onClick={() => this.eliminarEmail(email)}
                        >
                          Eliminar
                        </Button>
                      ]}
                    >
                      {email}
                    </List.Item>
                  )}
                />
              ) : (
                <div style={{ textAlign: 'center', color: '#999', padding: '20px' }}>
                  No hay emails agregados
                </div>
              )}
            </Form.Item>
          </Form>
        )}
      </Modal>
    );
  }
}

export default withApollo(ModalMandarEmail);
